import React from 'react';

interface DotProps {
  cx: number;
  cy: number;
  fill: string;
}

export const TriangleDot = ({ cx, cy, fill }: DotProps) => (
  <svg x={cx - 5} y={cy - 5} width={10} height={10} viewBox="0 0 10 10">
    <polygon
      points="5,0 10,10 0,10"
      fill={fill}
    />
  </svg>
);

export const StarDot = ({ cx, cy, fill }: DotProps) => {
  const points = '5,0 6.18,3.51 9.51,3.51 6.81,5.63 8,9.02 5,7.07 2,9.02 3.19,5.63 0.49,3.51 3.82,3.51';
  return (
    <svg x={cx - 5} y={cy - 5} width="10" height="10" viewBox="0 0 10 10">
      <polygon
        points={points}
        fill={fill}
      />
    </svg>
  );
};

export const CircleDot = ({ cx, cy, fill }: DotProps) => (
  <svg x={cx - 5} y={cy - 5} width={10} height={10} viewBox="0 0 10 10">
    <circle
      cx="5"
      cy="5"
      r="4"
      fill={fill}
    />
  </svg>
);
